<aside class="w-full h-full flex flex-col">
  <div class="flex justify-start mb-15">
    <a routerLink="/">
      <img src="assets/images/logo.png" alt="Logo" width="100" height="83" />
    </a>
  </div>
  <nav class="flex flex-col flex-1 justify-between">
    <!-- Main Menu -->
    <ul class="flex flex-col flex-1 gap-6">
      @for (nav of mainNavs(); track nav.route) {
        <li
          class="cursor-pointer text-[#363636]"
          [ngClass]="{ 'font-bold': !nav.children || nav.children.length < 1 }"
        >
          @if (nav.children && nav.children.length > 0) {
            <div
              class="flex items-center justify-between"
              tabindex="0"
              (click)="toggleSubMenu(nav)"
              (keydown)="toggleSubMenu(nav)"
            >
              <span class="border-b-4 border-transparent font-bold text-lg">
                {{ nav.label }}
              </span>
              <svg
                class="w-4 h-4 transition-transform duration-200"
                [class.rotate-180]="nav.expanded"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.96458 6.66675C4.25167 6.66675 3.89521 7.53809 4.41009 8.05297L9.47971 13.1226C9.79656 13.4394 10.3114 13.4394 10.6283 13.1226L15.6979 8.05297C16.2128 7.53809 15.8563 6.66675 15.1434 6.66675H4.96458Z"
                  fill="#333333"
                />
              </svg>
            </div>
            @if (nav.expanded) {
              <ul class="my-6 ml-4 flex flex-col gap-6">
                @for (child of nav.children; track child.route) {
                  <li class="cursor-pointer text-[#363636]">
                    <a
                      class="border-b-4 border-transparent text-lg"
                      [ngClass]="{
                        '!border-[#F6CD4D]': isActiveRoute(child.route),
                        'hover:border-[#F6CD4D]': !isActiveRoute(child.route),
                      }"
                      [routerLink]="child.route"
                      >{{ child.label }}
                    </a>
                  </li>
                }
              </ul>
            }
          } @else {
            <a
              class="border-b-4 border-transparent text-lg"
              [ngClass]="{
                '!border-[#F6CD4D]': isActiveRoute(nav.route),
                'hover:border-[#F6CD4D]': !isActiveRoute(nav.route),
              }"
              [routerLink]="nav.route"
              >{{ nav.label }}
            </a>
          }
        </li>
      }
    </ul>
    <!-- END Main Menu -->

    <!-- Others Section -->
    <ul class="flex flex-col gap-1">
      @for (nav of bottomNavs; track nav.route) {
        <li class="cursor-pointer font-bold text-[#363636] text-lg">
          <a
            [ngClass]="{
              'border-b-4 border-[#F6CD4D]': isActiveRoute(nav.route),
              'hover:border-b-4 hover:border-[#F6CD4D]': !isActiveRoute(
                nav.route
              ),
            }"
            [routerLink]="nav.route"
            >{{ nav.label }}</a
          >
        </li>
      }
    </ul>
    <!-- END other section -->
  </nav>
</aside>
